import { FinancingConfig } from './financingConfig.models';

export interface FinancingConfigState {
  ids: string[];
  entities: Record<string, FinancingConfig>;
  currentAccountingId: string | null;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_FINANCE_CONFIGS' }
  | {
      type: 'FETCH_FINANCE_CONFIGS_SUCCESS';
      payload: { financingConfigs: FinancingConfig[] };
    }
  | { type: 'FETCH_FINANCE_CONFIGS_FAILURE'; payload: { error: string } }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: FinancingConfigState = {
  ids: [],
  entities: {},
  currentAccountingId: null,
  isLoading: false,
  isLoaded: false,
  error: null,
};

export const financingConfigReducer = (
  state: FinancingConfigState,
  action: Action
): FinancingConfigState => {
  switch (action.type) {
    case 'FETCH_FINANCE_CONFIGS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_FINANCE_CONFIGS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.financingConfigs.map((i) => i.accountingId),
          ]),
        ],
        entities: action.payload.financingConfigs.reduce(
          (prev, curr) => ({
            ...prev,
            [curr.accountingId]: curr,
          }),
          state.entities
        ),
      };
    case 'FETCH_FINANCE_CONFIGS_FAILURE':
      return { ...state, isLoading: false, error: action.payload.error };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
